<template>
    <div class="dcs">
      <div class="container">
            <el-row :gutter="20">
                <el-col :span="24">
                    <h3>CCM 临床任务协作管理系统</h3>
                    <p>面向临床研究行业的项目管理系统，支持对项目过程中的任务的细粒度跟踪和管理，助力项目管理有条不紊。</p>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="4">
                    <div class="single-service-inner">
						<div class="thumb text-center">
							<img src="@/assets/img/pro/vms_ico_1.svg">
						</div>
						<h5>项目管理</h5>
						<p class="text-center">多项目并行管理，支持临床项目和非临床项目统一管理。</p>
					</div>
                </el-col>
                <el-col :span="5">
                    <div class="single-service-inner">
						<div class="thumb text-center">
							<img src="@/assets/img/pro/vms_ico_4.svg">
						</div>
						<h5>完美的编辑体验</h5>
						<p class="text-center">基于行业专家级最佳实践的内置任务模板，帮助PM轻松构建任务框架。 </p>
					</div>
                </el-col>
                <el-col :span="5">
                    <div class="single-service-inner">
						<div class="thumb text-center">
							<img src="@/assets/img/pro/mda_ico_3.svg">
						</div>
						<h5>与看板智能联动</h5>
						<p class="text-center">流程看板实时联动，自动根据业务流程图，生成临床项目任务，任务状态实时通过流程看板进行反馈。 </p>
					</div>
                </el-col>
                <el-col :span="5">
                    <div class="single-service-inner">
						<div class="thumb text-center">
							<img src="@/assets/img/pro/mda_ico_4.svg">
						</div>
						<h5>工时与变更管理</h5>
						<p class="text-center">任务与工时、标准工作模块相关联，支持任务变更流程。 </p>
					</div>
                </el-col>
                <el-col :span="5">
                    <div class="single-service-inner">
						<div class="thumb text-center">
							<img src="@/assets/img/pro/mda_ico_5.svg">
						</div>
						<h5>优异的用户体验</h5>
						<p class="text-center">极具匠心的UI设计，与众不同的操作体验，一切为了简单、直观、高效。 </p>
					</div>
                </el-col>
          </el-row>
          <section class="program-content">
            <el-row :gutter="20">
                <el-col :span="12">
                    <img src="@/assets/img/pro/ccm_pic_1.jpg">
                </el-col>
                <el-col :span="12">
                    <div class="program-des">
                        <h3 class="text-blue">面向临床研究领域量身打造的任务协作管理系统</h3>
                        <h4>文档目录规范化、标准化</h4>
                        <p>支持全局文档目录模板+项目级文档目录模板，规范化和标准化的复用</p>
                        <p>支持批量设置各目录的权限、负责人角色以及开放状态</p>
                        <p>默认支持项目文件目录、中心文件目录、数据与统计相关目录的分类管理。</p>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <div class="program-des">
                        <h3 class="text-blue">多项目并行管理，专业而简洁的任务视图</h3>
                        <h4>多角色多权限并行管理</h4>
                        <p>多项目并行管理，支持临床项目和非临床项目统一管理。</p>
                        <p>支持切换多个身份角色参与项目进度管理与任务协作</p>
                    </div>
                </el-col>
                <el-col :span="12">
                    <img src="@/assets/img/pro/ccm_pic_2.jpg">
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <img src="@/assets/img/pro/ccm_pic_3.jpg">
                </el-col>
                <el-col :span="12">
                    <div class="program-des">
                        <h3 class="text-blue">线下规划，线上执行，适用多种场景</h3>
                        <h4>支持将任务列表与Project MPP文件相互转化</h4>
                        <p>随时导出为Project文件进行动态调整</p>
                        <p>适应多种项目管理场景，线上线下迁移易如反掌</p>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <div class="program-des">
                        <h3 class="text-blue">量身定做，临床研究领域专属</h3>
                        <h4>CCM不是一个普通的任务管理平台</h4>
                        <p>专为临床研究领域打造，符合临床研究人员的工作模式和使用习惯</p>
                        <p>任务的创建、模板任务均支持与中心相关联，自动按中心生成多条任务</p>
                        <p>任务列表支持普通视图与中心分组视图，中心编号自动显示。</p>
                    </div>
                </el-col>
                <el-col :span="12">
                    <img src="@/assets/img/pro/ccm_pic_4.jpg">
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <img src="@/assets/img/pro/ccm_pic_5.jpg">
                </el-col>
                <el-col :span="12">
                    <div class="program-des">
                        <h3 class="text-blue">随心所欲的任务构建模式</h3>
                        <h4>追求极致的用户体验，让项目管理轻松自如</h4>
                        <p>无限级父子任务嵌套展示，任意级节点的任务导入和拷贝</p>
                        <p>基于行业实践的内置项目模板，可以一键生成一套完整的任务框架</p>
                        <p>相比传统通用任务管理软件，追求以简单的操作实现复杂的功能</p>
                        <p>深入浅出的诠释“让天下没有难管理的项目”</p>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <div class="program-des">
                        <h3 class="text-blue">多途径通知+提醒</h3>
                        <h4>强弱结合的提醒，任务再多也不会遗漏</h4>
                        <p>多种渠道的任务预警和提醒：实时消息、站内、多级警示标识、颜色等</p>
                        <p>按项目自由设置任务逾期提醒时间</p>
                    </div>
                </el-col>
                <el-col :span="12">
                    <img src="@/assets/img/pro/ccm_pic_6.jpg">
                </el-col>
            </el-row>
          </section>
      </div>
    </div>
</template>
<script>

export default{
    data() {
        return {

        };
    },
    methods: {
      
    }
}
</script>
<style scoped>
.program-des {
    padding: 60px 30px 0;
    text-align: center;
}
.program-des h4{
  margin-bottom: 30px;
}
.single-service-inner {
  position: relative;
  border-radius: 8px;
  background: #fff;
  margin-bottom: 30px;
  /*box-shadow: 0px 5px 30px rgba(126, 86, 255, 0.1);*/
  transition: all 0.4s ease-in;
  /*clip-path: polygon(0 10%, 100% 0%, 100% 90%, 0% 100%);*/
  padding: 70px 10px 30px;
}
.page-service-area .single-service-inner {
  padding: 20px ;
}
.single-service-inner.style-2 {
  padding: 40px 40px 50px;
}
.single-service-inner.style-2 .thumb {
  margin-bottom: 23px;
}
.single-service-inner.style-2 .thumb img {
  width: auto;
}
.single-service-inner:hover {
  box-shadow: 0px 5px 30px rgba(126, 86, 255, 0.2);
}
.single-service-inner .thumb {
  margin-bottom: 35px;
}
.program-adv-area .single-service-inner .thumb img {
  
  max-height: 150px;
}
.single-service-inner h5 {
  margin-bottom: 14px;
  text-align: center;
}
.single-service-inner p {
  transition: all 0.4s ease-in;
}

.service--details-area p {
  font-size: 18px;
}
</style>